import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, fonts } from '../../theme/tokens';

const RAW_VERSION = process.env.REACT_APP_VERSION || '';
const RAW_TAG = process.env.REACT_APP_RELEASE_TAG || '';

/** Short SHA for HUD; full value stays on /version.json */
export function getBuildVersion() {
  if (!RAW_VERSION) return null;
  return RAW_VERSION.length > 12 ? RAW_VERSION.slice(0, 7) : RAW_VERSION;
}

export function getBuildTag() {
  return RAW_TAG || null;
}

/**
 * Subtle release identity for deployed builds (footer + /version.json).
 * Hidden in local CRA when REACT_APP_VERSION is unset.
 */
export default function BuildIdentity({ sx } = {}) {
  const short = getBuildVersion();
  if (!short) return null;
  const tag = getBuildTag();
  const label = tag ? `${tag} · ${short}` : short;

  return (
    <Box
      component="footer"
      aria-label="Build version"
      sx={{
        mt: 'auto',
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Typography
        component="a"
        href="/version.json"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontFamily: fonts.numeric,
          fontSize: '0.7rem',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: colors.textSecondary,
          textDecoration: 'none',
          opacity: 0.55,
          '&:hover': { opacity: 0.9, color: colors.brass },
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
